import * as React from "react";
import DefaultModalWrapper from "src/components/shared/Modal/DefaultModalWrapper";
import { useModal } from "src/components/shared/Modal";
import {
  ContactForm,
  ContactModalButtons,
  ContactModalCloseIcon,
  ContactModalHeading,
  ContactModalTextArea,
} from "./ContactModal.components";
import ButtonBordered from "../shared/Button/ButtonBordered";
import axios from "axios";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import TextInput from "../shared/Inputs/TextInput";
import Checkbox from "../shared/Checkbox";
import { displayErrorToast, displaySuccessToast } from "../shared/Toasts/Toast";
import {
  ContactFormValues,
  ContactFormValuesOptions,
} from "./ContactFormValues";
import { CONTACT_FORM_SEND } from "src/utils/restEndpoints";

const ContactModal: React.FunctionComponent = () => {
  const { closeModal } = useModal();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<ContactFormValues>();

  const onSubmit: SubmitHandler<ContactFormValues> = async (
    data: ContactFormValues
  ) => {
    axios
      .post(`${process.env.REACT_APP_SOCKET_URL}${CONTACT_FORM_SEND}`, data)
      .then(() => {
        closeModal();
        displaySuccessToast("Message sent!");
        reset();
      })
      .catch(() => {
        displayErrorToast("Cannot send message");
      });
  };

  const submitForm = () => {
    handleSubmit(onSubmit)();
  };

  return (
    <DefaultModalWrapper>
      <ContactModalCloseIcon
        data-cy="contactModalCloseIcon"
        onClick={() => {
          reset();
          closeModal();
        }}
      />
      <ContactModalHeading>Contact us</ContactModalHeading>
      <ContactForm onSubmit={submitForm}>
        <TextInput
          aria="Your name"
          label="Your name"
          register={register("name", ContactFormValuesOptions.name)}
          errorMessage={errors.name?.message}
        />
        <TextInput
          aria="Email"
          label="Email"
          type="email"
          register={register("email", ContactFormValuesOptions.email)}
          errorMessage={errors.email?.message}
        />
        <ContactModalTextArea
          aria-label="Message"
          label="Message"
          register={register("message", ContactFormValuesOptions.message)}
          errorMessage={errors.message?.message}
        />
        <Controller
          name="policyAccepted"
          control={control}
          rules={ContactFormValuesOptions.policyAccepted}
          render={({ field }) => (
            <Checkbox
              {...field}
              label={
                <>
                  Our{" "}
                  <a
                    href="https://gorrion.io/resources/privacy-policy.pdf"
                    rel="noreferrer noopener"
                    onClick={e => e.stopPropagation()}
                    className="text-link"
                    target="_blank">
                    privacy policy
                  </a>
                </>
              }
              errorMessage={errors.policyAccepted?.message}
            />
          )}
        />
        <ContactModalButtons>
          <ButtonBordered themeColor="buttonPrimary" onClick={submitForm}>
            Send
          </ButtonBordered>
        </ContactModalButtons>
      </ContactForm>
    </DefaultModalWrapper>
  );
};

export default ContactModal;
